import React from "react";
import { reduxForm, Field } from "redux-form";
import { Loader, FormField } from "pickups-ui-library";
import { Alert, Button } from "reactstrap";
import { formatPhone } from "../../utils/helpers";

const PhoneNumberLookup = (props) => {
  const {
    handleSubmit,
    onSubmit,
    onCancel,
    pristine,
    submitting,
    error,
    initialValues,
    sentCodeByEmail,
    errorSendingByEmail,
    email,
  } = props;

  const renderMessaging = () => {
    if (sentCodeByEmail) {
      return `You were just sent a 6 digit code to ${email}`;
    } else if (errorSendingByEmail) {
      return `We were unable to locate an email address for your account. Please call us for assistance.`;
    } else {
      return `You were just sent a text containing a 6 digit code to ${formatPhone(
        initialValues.phoneNumber
      )}, you can use this code to access your account.`;
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Alert color={errorSendingByEmail ? "danger" : "success"}>
        {renderMessaging()}
      </Alert>
      <Field name="phoneNumber" type="hidden" component={"input"} />
      <Field
        name="verificationCode"
        type="text"
        component={FormField}
        label="Code"
        placeholder=""
      />
      {error && <Alert color={"danger"}>{error}</Alert>}
      <Button type="submit" disabled={pristine || submitting || error} block>
        {" "}
        {submitting ? <Loader color="#fff" /> : "Send"}{" "}
      </Button>
    </form>
  );
};

export default PhoneNumberLookup;
